import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import { medchartApi } from './medchartApi';
import streamingReducer, { purgeLegacyStreamingKeys } from './streamingSlice';
import { createTenantSwitchMiddleware } from './tenantSwitchMiddleware';

const rootReducer = combineReducers({
  [medchartApi.reducerPath]: medchartApi.reducer,
  user: userReducer,
  streaming: streamingReducer,
});

// Drop pre-tenant-scoping, browser-global AI chart keys. Streaming state is
// hydrated per tenant on selectTenant instead of being preloaded here.
purgeLegacyStreamingKeys();

const middlewares = [medchartApi.middleware, createTenantSwitchMiddleware(medchartApi)];

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...middlewares),
});

export default store;
